export class AuthResponse {
    rawData: string;
    validTo: Date;
}
